import { type SliderInputWidgetProps, WidgetType } from '@fruitful/types';

import type { ChatMessage } from '../types/ChatTypes';

export interface ActiveSliderWidget {
    messageId: string;
    props: SliderInputWidgetProps;
}

const isSliderWidgetProps = (
    props: Record<string, unknown> | null,
): props is SliderInputWidgetProps & Record<string, unknown> => {
    if (props == null) {
        return false;
    }

    return (
        typeof props.responseKey === 'string' &&
        typeof props.promptText === 'string' &&
        typeof props.min === 'number' &&
        typeof props.max === 'number'
    );
};

export const getActiveSliderWidget = (
    messages: ChatMessage[],
): ActiveSliderWidget | null => {
    for (let index = messages.length - 1; index >= 0; index -= 1) {
        const message = messages[index];
        if (message?.role !== 'assistant') {
            continue;
        }

        const uiContent = message.content.find(
            (content) =>
                content.type === 'ui' &&
                content.widget === WidgetType.SliderInput,
        );

        if (uiContent?.type !== 'ui' || !isSliderWidgetProps(uiContent.props)) {
            continue;
        }

        const hasUserReplyAfterWidget = messages
            .slice(index + 1)
            .some((reply) => reply.role === 'user');

        if (hasUserReplyAfterWidget) {
            return null;
        }

        return {
            messageId: message.id,
            props: uiContent.props,
        };
    }

    return null;
};
